/* tslint:disable */
/* eslint-disable */
export enum ProductionBonusType {
  Dollars = 'Dollars',
  Wrvu = 'WRVU'
}
